
import React from 'react';
import BusinessSearchField from '@/components/business/businessSearch/BusinessSearchField';

export interface SearchSectionProps {
  onBusinessSelect?: (business: any) => void;
  onCreateNew?: (businessName: string) => void;
  handleBusinessSelect?: (business: any) => void;
  handleCreateNew?: () => void;
  isMobile?: boolean;
}

const SearchSection: React.FC<SearchSectionProps> = ({ 
  onBusinessSelect,
  onCreateNew,
  handleBusinessSelect = onBusinessSelect,
  handleCreateNew: handleCreateNewProp = onCreateNew,
  isMobile = false
}) => {
  // Provide backward compatibility for both prop naming conventions
  const handleBusinessSelectFinal = handleBusinessSelect || onBusinessSelect;
  const handleCreateNewFinal = handleCreateNewProp || ((businessName: string) => {
    if (onCreateNew) onCreateNew(businessName);
  });

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        Search for an existing business or create a new one.
      </p>
      
      <div className="px-1 pb-1">
        <BusinessSearchField 
          onBusinessSelect={handleBusinessSelectFinal!}
          onCreateNew={handleCreateNewFinal}
        />
      </div>
    </div>
  );
};

export default SearchSection;
